/**
 * App layout: header, body (main), and footer
 */

import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ThemeSettings from './ThemeSettings';

export default function Layout({ children, wide = false }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const displayName =
    user?.student
      ? `${user.student.first_name} ${user.student.last_name}`
      : user?.faculty
      ? `${user.faculty.first_name} ${user.faculty.last_name}`
      : user?.parent
      ? `${user.parent.first_name} ${user.parent.last_name}`
      : user?.alumni
      ? `${user.alumni.first_name} ${user.alumni.last_name}`
      : user?.industryExpert
      ? `${user.industryExpert.first_name} ${user.industryExpert.last_name}`
      : user?.email || 'User';

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--bg-page)' }}>
      <header className="app-header shrink-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link
              to="/"
              className="flex items-center gap-3 opacity-95 hover:opacity-100 transition-opacity"
            >
              <span className="inline-flex items-center justify-center w-9 h-9 rounded-lg text-sm font-bold bg-white/15 border border-white/20">
                360
              </span>
              <span className="text-lg font-semibold tracking-tight">360 Feedback</span>
            </Link>

            <div className="flex items-center gap-2 sm:gap-3">
              <ThemeSettings />
              {user?.institute?.name && (
                <span
                  className="text-sm hidden md:inline truncate max-w-[220px] px-3 py-1.5 rounded-lg"
                  style={{ background: 'rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.92)' }}
                >
                  {user.institute.name}
                </span>
              )}
              <span className="user-chip">
                <span className="truncate max-w-[140px]">{displayName}</span>
                <span className="role-badge">{user?.role?.replace('_', ' ')}</span>
              </span>
              <button
                onClick={handleLogout}
                className="text-sm font-medium px-3 py-2 rounded-lg hover:bg-white/12 transition-colors"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className={`flex-1 w-full mx-auto px-4 sm:px-6 lg:px-8 py-8 ${wide ? 'max-w-[1680px]' : 'max-w-7xl'}`}>
        {children}
      </main>

      <footer
        className="shrink-0 border-t mt-auto"
        style={{ borderColor: 'var(--border-color)', backgroundColor: 'var(--bg-card)' }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
          <div
            className="flex flex-col items-center justify-center gap-1 text-center text-sm"
            style={{ color: 'var(--text-secondary)' }}
          >
            <span>© {new Date().getFullYear()} 360 Feedback. All rights reserved.</span>
            <span style={{ color: 'var(--text-muted)' }}>Faculty Feedback System</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
